<template>
	<sf-data-table
		ref="grpTable"
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:span-method="spanMethod"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcIdxNumWm/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdSalesList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		searchGraphList({ carCd }) {
			this.$sf_toggleLoading(true);

			this.setSearchParam_({ key: 'selRowCarCd', value: carCd });

			this.getGraphList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (rowIndex % 3 === 0) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
	}
};
</script>

<style></style>
